import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDIcon, FDStack } from '@facet-wealth/design';

const iconMap = {
  removed: 'closeCircle',
  minorChange: 'shuffle',
  majorChange: 'shuffle',
  added: 'addCircle',
  noChange: 'checkCircleIcon',
};

const colorMap = {
  removed: 'berry500',
  minorChange: 'textPrimary',
  majorChange: 'textPrimary',
  added: 'mint500',
  noChange: 'textPrimary',
};

export const PM2JourneyRoadmapAdjustmentDiffItem = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={'row'} alignItems={'center'} spacing={1}>
      <FDIcon
        size={'md'}
        icon={iconMap[resource.attr('status')]}
        color={colorMap[resource.attr('status')]}
      />
      <MetaControlField attr={'description'} />
    </FDStack>
  );
};
